import React from 'react';
import styles from './ToggleSwitch.module.css';

const ToggleSwitch = ({ isOn, handleToggle, id }) => {
  return (
    <div className={styles.toggleSwitch}>
      <input
        checked={isOn}
        onChange={handleToggle}
        className={styles.toggleCheckbox}
        id={id}
        type="checkbox"
      />
      <label className={styles.toggleLabel} htmlFor={id} />
    </div>
  );
};

export default ToggleSwitch;
